import { x } from '@cropink/ui-components';
import { ErrorBoundary } from '@sentry/react';
import { FC } from 'react';
import { Outlet, useNavigation } from 'react-router-dom';

import { AppInternalError } from '@containers/AppInternalError';
import { useGTM, useUTMParams } from '@hooks';

import styles from './NavigationProgress.module.css';

export const RootLayout: FC = () => {
  const navigation = useNavigation();

  useGTM();
  useUTMParams();

  return (
    <x.div color="content-primary" text="medium-75">
      <ErrorBoundary fallback={<AppInternalError />}>
        {navigation.state === 'loading' && (
          <div data-testid="navigation-progress" className={styles.bar} />
        )}
        <Outlet />
      </ErrorBoundary>
    </x.div>
  );
};
